import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1024;

export function useIsMobile() {
    const [isMobile, setIsMobile] = useState(() => window.innerWidth < MOBILE_BREAKPOINT);
    const [isTablet, setIsTablet] = useState(() => window.innerWidth >= MOBILE_BREAKPOINT && window.innerWidth < TABLET_BREAKPOINT);
    const [isNative, setIsNative] = useState(() => !!window.Capacitor?.isNativePlatform());

    useEffect(() => {
        const mobileQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
        const tabletQuery = window.matchMedia(`(min-width: ${MOBILE_BREAKPOINT}px) and (max-width: ${TABLET_BREAKPOINT - 1}px)`);

        const handleMobile = (e) => setIsMobile(e.matches);
        const handleTablet = (e) => setIsTablet(e.matches);

        mobileQuery.addEventListener('change', handleMobile);
        tabletQuery.addEventListener('change', handleTablet);

        return () => {
            mobileQuery.removeEventListener('change', handleMobile);
            tabletQuery.removeEventListener('change', handleTablet);
        };
    }, []);

    return { isMobile, isTablet, isNative };
}
